import { useCallback, useMemo, useState } from 'react';
import { useGetUnpickedPartsQuery } from '../../../../api/endpoints/parts';
import { useLanguage } from '../../../../contexts/LanguageContext';

const emptyFilters = {
    isDomestic: null,
    dealerNo: null,
    invoiceNo: '',
    deliveryNo: '',
    eFaturaNo: ''
};

const useUnpickedPartsReportData = () => {
    const { getCurrentLanguageId } = useLanguage();
    const languageId = useMemo(() => getCurrentLanguageId(), [getCurrentLanguageId]);

    const [{ filters, first, rows, page }, setState] = useState({
        filters: emptyFilters,
        first: 0,
        rows: 10,
        page: 1
    });

    const sharedParams = useMemo(
        () => ({
            isDomestic: filters.isDomestic === true || filters.isDomestic === false ? filters.isDomestic : null,
            dealerNo: filters.dealerNo || null,
            invoiceNo: filters.invoiceNo || null,
            deliveryNo: filters.deliveryNo || null,
            eFaturaNo: filters.eFaturaNo || null,
            languageId
        }),
        [filters, languageId]
    );

    const queryParams = useMemo(
        () => ({
            ...sharedParams,
            pageNumber: page,
            pageSize: rows
        }),
        [sharedParams, page, rows]
    );

    const { data, isLoading, isFetching } = useGetUnpickedPartsQuery(queryParams, {
        refetchOnMountOrArgChange: true
    });

    const handleApplyFilters = useCallback((newFilters) => {
        setState((prev) => ({
            ...prev,
            filters: {
                isDomestic: newFilters.isDomestic === true || newFilters.isDomestic === false ? newFilters.isDomestic : null,
                dealerNo: newFilters.dealerNo || null,
                invoiceNo: (newFilters.invoiceNo || '').trim(),
                deliveryNo: (newFilters.deliveryNo || '').trim(),
                eFaturaNo: (newFilters.eFaturaNo || '').trim()
            },
            first: 0,
            page: 1
        }));
    }, []);

    const handleResetFilters = useCallback(() => {
        setState({
            filters: emptyFilters,
            first: 0,
            rows: 10,
            page: 1
        });
    }, []);

    const onPage = useCallback((event) => {
        setState((prev) => ({
            ...prev,
            first: event.first,
            rows: event.rows,
            page: event.page + 1
        }));
    }, []);

    return {
        rows: data?.items || [],
        totalRecords: data?.totalCount || 0,
        loading: isLoading || isFetching,
        filters,
        lazyParams: { first, rows, page },
        onPage,
        handleApplyFilters,
        handleResetFilters,
        exportParams: sharedParams
    };
};

export default useUnpickedPartsReportData;
